import { Box } from "@mui/material";
import { htmlImageSx, useImagePreview } from "./HtmlImage";

export function HtmlView(props: { html: string }) {
    const preview = useImagePreview();

    // the html comes from our own editor, which limits the markup it can produce
    return (
        <>
            <Box
                sx={{
                    // a pasted url or another long run of text has nowhere to break,
                    // so let it break anywhere rather than push the row wider
                    overflowWrap: "anywhere",
                    "& p": { m: 0 }, "& ul, & ol": { my: 0, pl: 3 },
                    ...htmlImageSx,
                }}
                onClick={preview.onClick}
                dangerouslySetInnerHTML={{ __html: props.html }}
            />
            {preview.element}
        </>
    );
}
